/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Downloadlinkscolumnclicks3Inputs */

const en_downloadlinkscolumnclicks3 = /** @type {(inputs: Downloadlinkscolumnclicks3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clicks`)
};

const de_downloadlinkscolumnclicks3 = /** @type {(inputs: Downloadlinkscolumnclicks3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klicks`)
};

/**
* | output |
* | --- |
* | "Clicks" |
*
* @param {Downloadlinkscolumnclicks3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const downloadlinkscolumnclicks3 = /** @type {((inputs?: Downloadlinkscolumnclicks3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Downloadlinkscolumnclicks3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_downloadlinkscolumnclicks3(inputs)
	return de_downloadlinkscolumnclicks3(inputs)
});
export { downloadlinkscolumnclicks3 as "downloadLinksColumnClicks" }